import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import assignmentReports from './assignmentReports.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import calls from './calls.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import companies from './companies.json';
import components from './components.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import cortexBudgetReconciliation from './cortexBudgetReconciliation.json';
import cortexConfidence from './cortexConfidence.json';
import cortexModels from './cortexModels.json';
import cortexUrls from './cortexUrls.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import datePicker from './datePicker.json';
import emoji from './emoji.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inbox from './inbox.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import kanban from './kanban.json';
import labelsMgmt from './labelsMgmt.json';
import license from './license.json';
import login from './login.json';
import macros from './macros.json';
import onboarding from './onboarding.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import sessionLimit from './sessionLimit.json';
import signup from './signup.json';
import sla from './sla.json';
import teamsSettings from './teamsSettings.json';
import whatsappTemplates from './whatsappTemplates.json';
import changelog from './changelog.json';
import diagnostics from './diagnostics.json';
import flowbuilder from './flowbuilder.json';
import externalCredentials from './externalCredentials.json';
import externalConnections from './externalConnections.json';
import userRoles from './userRoles.json';
import brandKit from './brandKit.json';
import brandKitData from './brandKitData.json';
import whatsappTemplateMgmt from './whatsappTemplateMgmt.json';

export default {
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...assignmentReports,
  ...automation,
  ...bulkActions,
  ...calls,
  ...campaign,
  ...cannedMgmt,
  ...chatlist,
  ...companies,
  ...components,
  ...contact,
  ...contactFilters,
  ...cortexBudgetReconciliation,
  ...cortexConfidence,
  ...cortexModels,
  ...cortexUrls,
  ...conversation,
  ...csatMgmt,
  ...datePicker,
  ...emoji,
  ...general,
  ...generalSettings,
  ...helpCenter,
  ...inbox,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...kanban,
  ...labelsMgmt,
  ...license,
  ...login,
  ...macros,
  ...onboarding,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...sessionLimit,
  ...signup,
  ...sla,
  ...teamsSettings,
  ...whatsappTemplates,
  ...changelog,
  ...diagnostics,
  ...flowbuilder,
  ...externalCredentials,
  ...externalConnections,
  ...userRoles,
  ...brandKit,
  ...brandKitData,
  ...whatsappTemplateMgmt,
};
